export const sortTypes = {
  asc: 'asc',
  desc: 'desc',
};

export function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

const reactComponentToTokens = (component, tokens) => {
  const { props } = component;

  if (!props?.children) {
    return tokens;
  }

  if (typeof props.children === 'string') {
    tokens.push(props.children.toLowerCase());
    return tokens;
  }

  if (Array.isArray(props.children)) {
    props.children.forEach((child) => {
      if (!child) return;

      if (typeof child === 'string') {
        tokens.push(child.toLowerCase());
        return;
      }

      if (child.props) {
        return reactComponentToTokens(child, tokens);
      }
    });
    return tokens;
  }

  if (props.children.props) {
    return reactComponentToTokens(props.children, tokens);
  }

  return tokens;
};

const reactComponentToString = (component) =>
  reactComponentToTokens(component, [])
    .filter((t) => t)
    .join(' ');

export function descendingComparator(a, b, orderBy, nestedOrderBy) {
  if (!nestedOrderBy) {
    const valueA = b[orderBy];
    const valueB = a[orderBy];

    if (valueA?.props && valueB?.props) {
      const componentA = reactComponentToString(valueA);
      const componentB = reactComponentToString(valueB);
      return componentA.localeCompare(componentB);
    }

    if (valueA < valueB) return -1;
    if (valueB > valueA) return 1;
    return 0;
  }

  const nestedArrayA = a[orderBy] || [];
  const nestedArrayB = b[orderBy] || [];
  const sumOfNestedOrderByA = nestedArrayA.reduce(
    (acc, curr) => acc + curr[nestedOrderBy],
    0
  );

  const sumOfNestedOrderByB = nestedArrayB.reduce(
    (acc, curr) => acc + curr[nestedOrderBy],
    0
  );

  if (sumOfNestedOrderByB < sumOfNestedOrderByA) return -1;
  if (sumOfNestedOrderByB > sumOfNestedOrderByA) return 1;
  return 0;
}

export function getComparator(order, orderBy, nestedOrderBy = null) {
  return order === sortTypes.desc
    ? (a, b) => descendingComparator(a, b, orderBy, nestedOrderBy)
    : (a, b) => -descendingComparator(a, b, orderBy, nestedOrderBy);
}
